import capitalize from 'lodash/capitalize.js';

export default {
    computed: {
        quizType() {
            return this.$store.getters[`QuizBuilder/${this.uuid}/get`]('type');
        },

        survey() {
            return this.quizType === 'survey';
        },
    },

    methods: {
        formatType(cap = false) {
            if (this.survey) return cap ? capitalize(this.quizType) : this.quizType;

            return cap ? 'Quiz' : 'quiz';
        },
    },
};
